import { Vue } from "vue-property-decorator";
import "./app-sidebar.scss";

export class AppSidebarComponent extends Vue {}
